import React, { useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { v4 } from 'uuid';

const C2InputText = (props) => {
    const { defaultValue, floatingLabel, icon, iconPos, hint, invalid, disabled, size, label, tooltip, placeholder } = props;
    const [value, setValue] = useState(defaultValue);
    const id = v4();
    const classNames = () => {
        let classes = "block";
        if (invalid)
            classes += " p-invalid";
        if (size) {
            switch (size) {
                case "small":
                    classes += " p-inputtext-sm";
                    break;
                case "large":
                    classes += " p-inputtext-lg";
                    break;
                default:
                    classes += " p-inputtext";
                    break;
            }
        }
        return classes;
    };
    const wrapperClass = () => {
        let classes = "";
        if (floatingLabel)
            classes += " p-float-label";
        if (icon) {
            classes += " p-input-icon-" + iconPos;
        }
        return classes;
    };
    const baseInput = (React.createElement("span", { className: wrapperClass() },
        icon && React.createElement("i", { className: icon }),
        !floatingLabel && label && React.createElement("label", { htmlFor: id }, label),
        React.createElement(InputText, { id: id, value: value, className: classNames(), disabled: disabled, tooltip: tooltip, placeholder: placeholder }),
        floatingLabel && label && React.createElement("label", { htmlFor: id }, label),
        hint && React.createElement("small", { id: id, className: "block" }, hint)));
    let elem = baseInput;
    return elem;
};

export { C2InputText as default };
//# sourceMappingURL=index.js.map
